import { useState } from 'react';

import { useDirectTradingAccountSecurityPricePerformance } from './hooks/useDirectTradingAccountSecurityPricePerformance';
import { PerformanceLoadingState } from './loading-state/PerformanceLoadingState';
import { PerformanceSection } from './PerformanceSection';

import { DateRangeOption } from '../../../../../graphql/schema';

type PerformanceChartSectionProps = {
  accountId: string;
  securityId: string;
};

export const PerformanceChartSection: React.FC<PerformanceChartSectionProps> = ({ accountId, securityId }) => {
  const [dateRangeOption, setDateRangeOption] = useState<DateRangeOption>(DateRangeOption.Today);

  const {
    data: newData,
    loading,
    previousData,
  } = useDirectTradingAccountSecurityPricePerformance(accountId, securityId, dateRangeOption);

  const data = newData ?? previousData;
  const hasValidData = data && 'financialSecurity' in data.account;
  const directTradingAccount = hasValidData ? data.account : null;

  if (loading && !data) return <PerformanceLoadingState />;
  if (!hasValidData || !directTradingAccount) return null;

  const { marketSchedule } = data;
  const { financialSecurity } = directTradingAccount;
  const { pricePerformance } = financialSecurity;
  const { timeSeries } = pricePerformance;
  const { returns } = pricePerformance;
  const { statistics } = financialSecurity;
  const { latestPrice } = statistics;

  const isLoadingWithPreviousData = loading && !newData && !!previousData;

  return (
    <PerformanceSection
      latestPriceAmount={latestPrice.amount}
      latestPriceCurrentAsOf={latestPrice.formattedCurrentAsOf}
      latestReturnsAmount={returns.amount}
      latestReturnsPercentage={returns.percentage}
      timeSeries={timeSeries}
      isLoading={isLoadingWithPreviousData}
      marketSchedule={marketSchedule}
      dateRangeOption={dateRangeOption}
      onDateRangeChange={setDateRangeOption}
    />
  );
};
